/**
 * The key for the billing id stored in jitsiLocalStorage.
 */
export const BILLING_ID = 'billingId';

/**
 * The prefix for the vpaas tenant.
 */
export const VPAAS_TENANT_PREFIX = 'vpaas-magic-cookie';
